module.exports = "/fonts/h2h-picturemark-d-e46c107678e44fea7261daf95593f764.svg";